import { DBCollectionActions, DBCollectionSchools, DBCollectionUsers, DBCollectionRCCustomers, DBCollectionActivities, DBCollectionCategories } from '../../utils/Constants';

import * as Constants from "../../utils/Constants";

import User from "../../data/user/User";
import { dbCurrentUser } from '../../../specific/services/Specific_Auth';
import { EventRegister } from "../../utils/EventListeners";
import { EventUserAuthDB } from "../../utils/Constants";

import { build, version } from "../../../../package.json";
import { buildLocalDB, getLocalActivities, getLocalCategories, getLocalDocs, getLocalGameImages, getLocalGameLabels, getLocalintegrationSteps, getLocalNews, getLocalQuotes, getLocalSuperPowers, getLocalTips, recordLocalActivities, recordLocalCategories, recordLocalDocs, recordLocalGameImages, recordLocalGameLabels, recordLocalLaunchSteps, recordLocalNews, recordLocalQuotes, recordLocalSuperPowers, recordLocalTips, recordUsers } from '../../../specific/utils/LocalStorage';
import Activity from '../../models/Activity';
import { getLanguage } from '../../utils/Localization/Localization';
import { Platform } from 'react-native';
import { PremiumCard } from '../../components/LiliHQ/LHQCreateCode';

import { query, collection, db, getDocs, where, doc, getDoc, updateDoc, runTransaction, setDoc, onSnapshot, addDoc, deleteDoc } from "../../../specific/services/Firebase/Firebase";
import { userOptions } from '../Auth';
import { School } from '../../components/Authentication/Landing/SignUpScreen/TeacherSignUp';
import { AppTarget, getAppTarget } from '../../../specific/utils/Navigation/Host';
import { appWriteAddLevelToUser } from '../../../specific/services/AppWrite/AppWriteDatabase';
import { AsyncStorageKey, getItemFromAsyncStorage } from '../../utils/AsyncStorage/AsyncStorage';

export let dbListeners = [];

/**
 * 
 * ADMIN
 */
export const getUsersStats = async () => {
    try {
        const userStatRef = doc(db, Constants.DBCollectionStats, "users");
        const querySnapshot = await getDoc(userStatRef);
        if (querySnapshot.exists() === true) {
            const result = querySnapshot.data();
            return result;
        } else {
            return null;
        }
    } catch (error) {
        return null;
    }
}

export const createPremiumCardForCustomers = async (premiumCard: PremiumCard) => {
    try {
        const creationResult = await setDocument({ aCollection: 'db_premium_cards', content: premiumCard, key: premiumCard.code });
        return creationResult;
    } catch (error) {
        throw error;
    }
}

export const deleteAPremiumCard = async (premiumCard: PremiumCard) => {
    try {
        const creationResult = await deleteDocument({ aCollection: 'db_premium_cards', content: premiumCard, key: premiumCard.code });
        return creationResult;
    } catch (error) {
        throw error;
    }
}

// ACHAT STRIPE
export const addPreSubToUser = async (data: { user_id: string, sub_id: string, duration_in_month: number, presubId: string }) => {
    const { user_id, sub_id, duration_in_month, presubId } = data;
    const start_date = new Date();
    let expires_date = new Date();
    expires_date.setMonth(start_date.getMonth() + duration_in_month);
    try {
        const updateResult = await addDataToUser({
            key: "sub", value: {
                creationDate: start_date.getTime(),
                start_date: start_date.getTime(),
                expires_date: start_date.getTime(),
                pre_expires_date: expires_date.getTime(),
                pre_sub_id: presubId,
                auto_renewing: false,
                origin: "lili",
                product_id: sub_id
            }, user_id
        });
        return updateResult;
    } catch (error) {
        throw error;
    }
}

export const markSucessToSubToUser = async (data: { user_id: string }) => {
    const { user_id } = data;
    try {
        const updateResult = await addDataToUser({
            key: "sub",
            value: {
                product_id: "stripe_success"
            },
            user_id
        });
        return updateResult;
    } catch (error) {
        throw error;
    }
}

export const removePreSubToUser = async (data: { user_id: string }) => {
    const { user_id } = data;
    const start_date = new Date();
    try {
        const updateResult = await addDataToUser({
            key: "sub",
            value: {
                creationDate: start_date.getTime(),
                start_date: start_date.getTime(),
                expires_date: start_date.getTime(),
                pre_expires_date: start_date.getTime(),
                auto_renewing: false,
                origin: "lili",
                product_id: "stripe_cancel"
            },
            user_id
        });
        return updateResult;
    } catch (error) {
        throw error;
    }
}

// ********** SET A NEW DOCUMENT IN DB ACTIVITIES  **********
export const setDBActivity = async (data: { key: string, value: any }) => {
    const { key, value } = data;
    try {
        const activityRef = doc(db, DBCollectionActivities, key);
        const setResult = await setDoc(activityRef, value);
        return setResult;
    } catch (error) {
        throw error;
    }
};

// ******************** ADD OR UPDATE DOCUMENT IN DB CATEGORIES  ********************
// ********** ADD A NEW DOCUMENT IN DB CATEGORIES  **********
export const addDBCategory = async (data: { key: string, value: any }) => {
    const { key, value } = data;
    try {
        // const categoryRef = collection(db, DBCollectionCategories, key);
        // const addCategoryResult = await addDoc (categoryRef, value)
        const categoryRef = doc(db, DBCollectionCategories, key);
        await setDoc(categoryRef, value)
        // return "La nouvelle categorie a bien été enregistrée avec succès!"
        return `La nouvelle categorie " ${key} " a bien été enregistrée avec succès!`
    } catch (error) {
        throw error
    }
};
// ********** UPDATE AN EXISTING DOCUMENT IN DB CATEGORIES  **********
export const setDBCategory = async (data: { key: string, value: any }) => {
    const { key, value } = data;
    try {
        const categoryRef = doc(db, DBCollectionCategories, key);
        // const setCategoryResult = await setDoc(categoryRef, value);
        // return setCategoryResult;
        await setDoc(categoryRef, value);
        // return "La categorie a bien été réactualisée avec succès!"
        return `La categorie " ${key} " a bien été réactualisée avec succès!`
    } catch (error) {
        throw error
    }
};

// ******************** ADD OR UPDATE DOCUMENT IN DB NEWS  ********************
// ********** ADD A NEW DOCUMENT IN DB NEWS **********
export const addDBNews = async (data: { value: any }) => {
    const { value } = data;
    try {
        const newsRef = collection(db, Constants.DBCollectionNews);
        await addDoc(newsRef, value);
        return `La news " ${value.title.fr} " a bien été enregistrée avec succès!`;
    } catch (error) {
        throw error
    }
};
// ********** UPDATE AN EXISTING DOCUMENT IN DB NEWS  ********** 
export const setDBNews = async (data: { key: string, value: any }) => {
    const { key, value } = data;
    try {
        const newsRef = doc(db, Constants.DBCollectionNews, key);
        await setDoc(newsRef, value);
        return `La news " ${value.title.fr} " a bien été réactualisée avec succès!`;
    } catch (error) {
        throw error
    }
}

/**
 * 
 * USER
 */
export const addDataToUser = async (data: { key: string, value: any, user_id: string }) => {
    const { user_id, key, value } = data;
    try {
        const updateResult = await addMultipleDataToUser({ pairs: [{ key, value }], user_id });
        return updateResult;
    } catch (error) {
        throw error;
    }
}

export const addMultipleDataToUser = async (data: { pairs: { key: string, value: any }[], user_id: string }) => {
    try {
        const { user_id, pairs } = data;
        const last_update = new Date().getTime();
        let dataToUpdate = { last_update };
        for (const aPairIndex in pairs) {
            if (Object.prototype.hasOwnProperty.call(pairs, aPairIndex)) {
                const aPair: { key: string, value: any } = pairs[aPairIndex];
                dataToUpdate[aPair.key] = aPair.value;
            }
        }
        const userDoc = doc(db, DBCollectionUsers, user_id);
        const updateResult = await updateDoc(userDoc, dataToUpdate);
        return updateResult;
    } catch (error) {
        throw error;
    }
};

export const getUserWithId = async (data: { user_id: string }) => {
    const { user_id } = data;
    try {
        const userDoc = doc(db, DBCollectionUsers, user_id);
        const userQuery = query(userDoc);
        const querySnapshot = await getDoc(userQuery);
        if (querySnapshot.exists() === true) {
            const userData = querySnapshot.data();
            if (userData.build === undefined) {
                // Cela signifie que nous avons un utilisateur des versions 1. Il faut migrer ses favoris
                if (userData.favorites !== undefined) {
                    let newFavorites: string[] = [];
                    for (const aSectionKey in userData.favorites) {
                        if (Object.prototype.hasOwnProperty.call(userData.favorites, aSectionKey)) {
                            if (aSectionKey !== "version") {
                                const aFavArray: string[] = userData.favorites[aSectionKey];
                                newFavorites = newFavorites.concat(aFavArray);
                            }
                        }
                    }
                    await addDataToUser({
                        key: "favorite_activities",
                        value: newFavorites,
                        user_id
                    });
                }
                // Migrer ses livres favories
                if (userData.fav_books !== undefined) {
                    let newFavoriteBooks: string[] = [];
                    for (const aSectionKey in userData.fav_books) {
                        if (Object.prototype.hasOwnProperty.call(userData.fav_books, aSectionKey)) {
                            if (aSectionKey !== "version") {
                                const aFavArray: string[] = userData.fav_books[aSectionKey];
                                newFavoriteBooks = newFavoriteBooks.concat(aFavArray);
                            }
                        }
                    }
                    await addDataToUser({
                        key: "favorite_books",
                        value: newFavoriteBooks,
                        user_id
                    });
                }
                await addDataToUser({
                    key: "creation_version",
                    value: "1.X",
                    user_id
                });
                await addDataToUser({
                    key: "creation_build",
                    value: 347,
                    user_id
                });
                await addDataToUser({
                    key: "version",
                    value: version,
                    user_id
                });
                await addDataToUser({
                    key: "build",
                    value: parseInt(build),
                    user_id
                });
            }
            return userData;
        } else {
            return undefined;
        }
    } catch (error) {
        throw error;
    }
}

export const getUsers = async () => {
    try {
        const usersQuery = query(collection(db, DBCollectionUsers));
        const querySnapshot = await getDocs(usersQuery);
        if (querySnapshot.empty === true) {
            return [];
        } else {
            let usersData = {};
            for (const aUserIndex in querySnapshot.docs) {
                if (Object.prototype.hasOwnProperty.call(querySnapshot.docs, aUserIndex)) {
                    const aUser = querySnapshot.docs[aUserIndex];
                    usersData[aUser.id] = aUser.data();
                }
            }
            recordUsers(usersData);
            return usersData;
        }
    } catch (error) {
        throw error;
    }
}

export const revokeDBListeners = () => {
    for (const aDbListenerIndex in dbListeners) {
        if (Object.prototype.hasOwnProperty.call(dbListeners, aDbListenerIndex)) {
            const aDBListener = dbListeners[aDbListenerIndex];
            aDBListener();
        }
    }
    dbListeners = [];
}

export const getUserCardsWithEmail = async (data: { user_email: string }) => {
    const { user_email } = data;
    try {
        const usersQuery = query(collection(db, Constants.DBCollectionPremiumCards), where("customer_email", "==", user_email));
        const querySnapshot = await getDocs(usersQuery);
        if (querySnapshot.empty === false) {
            const userDoc = querySnapshot.docs;
            return userDoc;
        } else {
            return [];
        }
    } catch (error) {
        throw error;
    }
}

export const getUserWithEmail = async (data: { user_email: string }) => {
    const { user_email } = data;
    try {
        const usersQuery = query(collection(db, DBCollectionUsers), where("email", "==", user_email));
        const querySnapshot = await getDocs(usersQuery);
        if (querySnapshot.empty === false) {
            const userDocs = querySnapshot.docs;
            return userDocs;
        } else {
            return undefined;
        }
    } catch (error) {
        throw error;
    }
}

export const checkUserDd = async (data: { user_id: string, dbUserData: any }) => {
    const { user_id, dbUserData } = data;
    // To
    try {
        let needToUpdate: boolean = false;
        let updateUserData = dbUserData.data;
        if (updateUserData === undefined) {
            needToUpdate = true;
            updateUserData = {
                last_versions: {
                    [Platform.OS]: build
                }
            }
        } else if (dbUserData.data.last_versions === undefined) {
            needToUpdate = true;
            updateUserData = dbUserData.data;
            updateUserData.last_versions = {
                [Platform.OS]: build
            }
        } else {
            updateUserData = dbUserData.data;
            let updateUserDataLastVersions = updateUserData.last_versions;
            if (updateUserDataLastVersions[Platform.OS] === undefined) {
                needToUpdate = true;
                updateUserDataLastVersions[Platform.OS] = build;
            } else if (updateUserDataLastVersions[Platform.OS] < build) {
                needToUpdate = true;
                updateUserDataLastVersions[Platform.OS] = build;
            }
        }
        if (dbUserData.creation_build !== undefined) {
            needToUpdate = true;
            updateUserData.creation = {
                build: dbUserData.creation_build,
                date: dbUserData.creation_date,
                version: dbUserData.creation_version
            }
        }
        if (needToUpdate === true) {
            // Il faut mettre à jour le compte de l'utilisateur
            addDataToUser({ key: "data", value: updateUserData, user_id: user_id });
        }

    } catch (error) {
    }
}

export const addTeacherCodeToUser = async (data: { user_id: string }) => {
    const { user_id } = data;
    try {
        const updateResult = await addDataToUser({ key: "profile", value: "teacher", user_id });
        return updateResult;
    } catch (error) {
        throw error;
    }
}

export const addFilterToUser = async (data: { user_id: string, filters: string[] }) => {
    const { user_id, filters } = data;
    try {
        const updateResult = await addDataToUser({ key: "filter_by_level", value: filters, user_id });
        return updateResult;
    } catch (error) {
        throw error;
    }
}

export const addLevelToUser = async (data: { user_id: string, level: string }) => {
    const { user_id, level } = data;
    try {
        const appTarget: AppTarget = getAppTarget();
        if ((appTarget === "public") || (appTarget === "lhq")) {
            const updateResult = await addMultipleDataToUser({ pairs: [{ key: "children_level", value: level }, { key: "filter_by_level", value: [level] }], user_id });
            return updateResult;
        } else {
            const updateResult = await appWriteAddLevelToUser({ user_id, level });
            return updateResult;
        }

    } catch (error) {
        throw error;
    }
}

export const addSubToUser = async (data: { user_id: string, sub_id: string, duration_in_month?: number, expiration_date?: number, origin?: string, card_id?: string, offer?: string }) => {
    const { user_id, sub_id, duration_in_month = 0, expiration_date = 0, origin = "lili", card_id = "", offer = "unknown" } = data;
    const start_date = new Date();
    let expires_date = new Date();
    expires_date.setMonth(start_date.getMonth() + duration_in_month);
    let expiration_date_ts = expires_date.getTime();
    if (expiration_date > 0) {
        expiration_date_ts = expiration_date;
    }
    try {
        const sub = {
            creationDate: start_date.getTime(),
            start_date: start_date.getTime(),
            expires_date: expiration_date_ts,
            auto_renewing: false,
            origin,
            product_id: sub_id,
            card_id,
            offer,
            duration: duration_in_month
        };
        const updateResult = await addDataToUser({
            key: "sub", value: sub, user_id
        });
        const userInstacen: User = User.getInstance();
        userInstacen.addSubToUser(sub);
        return updateResult;
    } catch (error) {
        throw error;
    }
}

// Nous allons supprimer les avis si l'utilisateur en a déposé
// Nous allons supprimer les actions si l'utilisateur en a faite
// Nous allons supprimer les données de rc_customers s'il y en a
// Nous allons supprimer les données de revenueCat s'il y a un utilisateur connecté
// Nous allons supprimer sa fiche utilisateur également
export const deleteUser = async (data: { user_id: string }) => {
    const { user_id } = data;
    try {
        // Suppression de l'utilisateur dans l'auth
        const authUser = dbCurrentUser();
        if ((authUser !== null) && (authUser !== undefined)) {
            await authUser.delete();
        }
        await deleteActions({ user_id });
        await deleteRevenueCat({ user_id });
        const aDoc = doc(db, DBCollectionUsers, user_id);
        await deleteDoc(aDoc);
        return true
    } catch (error) {
        throw error;
    }
}

export const deleteActions = async (data: { user_id: string }) => {
    const { user_id } = data;
    try {
        const aDoc = doc(db, DBCollectionActions, user_id);
        await deleteDoc(aDoc);
        return true
    } catch (error) {
        return false;
    }
}

export const deleteRevenueCat = async (data: { user_id: string }) => {
    const { user_id } = data;
    try {
        const aDoc = doc(db, DBCollectionRCCustomers, user_id);
        await deleteDoc(aDoc);
        return true
    } catch (error) {
        return false;
    }
}

/**
 * 
 * Activities
 */
export function getActivities() {
    return new Promise(function (resolve, reject) {
        getCollection({ collection: "acti", query: "" }).then((result) => {
            resolve(result);
        }).catch((error) => {
            reject(error);
        });
    });
}

export function saveActivities(data: { key: string, content: any }) {
    return new Promise(function (resolve, reject) {
        const { key, content } = data;
        Database.setDocument({ aCollection: "acti", key: key, content: content }).then((result) => {
            resolve(result);
        }).catch((error) => {
            reject(error);
        });
    });
}

/**
 * 
 * ECOLE
 */

export const getSchoolId = async (data: { school: School }) => {
    const { school } = data;
    try {
        let resultWithFrEduId: boolean = false;
        let querySnapshot = undefined;
        const schoolsCollection = collection(db, DBCollectionSchools);
        if (school.uai !== undefined) {
            const firstQuery = query(schoolsCollection, where("uai", "==", school.uai));
            querySnapshot = await getDocs(firstQuery);
            if (querySnapshot.empty === false) {
                resultWithFrEduId = true;
            }
        }
        if (resultWithFrEduId === false) {
            const secondQuery = query(schoolsCollection, where("name", "==", school.name), where("zipcode", "==", school.zipcode), where("city", "==", school.city));
            querySnapshot = await getDocs(secondQuery);
        }
        if ((querySnapshot !== undefined) && (querySnapshot.empty === false)) {
            const result = querySnapshot.docs;
            return result[0].id;
        } else {
            const newSchoolId = await createSchool({ school });
            return newSchoolId;
        }
    } catch (error) {
        throw error;
    }
};

export const createSchool = async (data: { school: School }) => {
    try {
        const newSchoolData = await addDocument({ collection: DBCollectionSchools, content: data.school });
        return newSchoolData.id;
    } catch (error) {
        throw error;
    }
}

/**
 * GIFT
 */

export const createGiftForUser = async (data: { gift: any }) => {
    const { gift } = data;
    try {
        const newGift = await addDocument({ collection: Constants.DBCollectionGifts, content: gift });
        return {
            isCreated: true,
            id: newGift.id
        };
    } catch (error) {
        return {
            isCreated: false,
            id: ""
        };
    }
}

export const createUserWithData = async (data: { context: string, email: string, user_id: string, options?: userOptions }) => {
    const { user_id, options = {}, email, context } = data;
    const { optInNewsletter = false, optInCoachNewsLetter = false, firstname = "", lastname = "", school_id = "", classes = [], tneEnable = false } = options;
    let newUserDocumentContent = {
        email,
        version,
        build: parseInt(build),
        creation_version: version,
        creation_build: parseInt(build),
        creation_date: new Date().getTime(),
        last_update: new Date().getTime(),
        profile: context
    }
    for (const anOptionKey in options) {
        if (Object.prototype.hasOwnProperty.call(options, anOptionKey)) {
            const anOptionValue = options[anOptionKey];
            if ((anOptionKey === "level") || (anOptionKey === "function")) {
                newUserDocumentContent["function"] = anOptionValue;
            } else {
                newUserDocumentContent[anOptionKey] = anOptionValue;
            }
        }
    }
    try {
        // Si nous créons un professeur nous allons d'abord lui créer un code
        await setDocument({
            aCollection: Constants.DBCollectionUsers,
            content: newUserDocumentContent,
            key: user_id
        });
        return true;
    } catch (error) {
        throw error;
    }
}

export const addUserWithData = async (data: { user_id: string, user_email: string, school_name: string, school_zipcode: string, opt_in: boolean, sub_id?: string, duration_in_month?: number, addCode?: boolean }) => {
    try {
        const { user_id, user_email, school_name, school_zipcode, opt_in, sub_id, duration_in_month = 1, addCode = false } = data;
        const today = new Date();
        let userData = {
            creation_date: today.getTime(),
            email: user_email,
            optIn: opt_in,
            sub: undefined
        }
        if (sub_id !== undefined) {
            let expires_date = new Date();
            expires_date.setMonth(today.getMonth() + duration_in_month);
            userData.sub = {
                creationDate: today.getTime(),
                start_date: today.getTime(),
                expires_date: expires_date.getTime(),
                auto_renewing: false,
                origin: "lili",
                product_id: sub_id,
            }
        }
        // On va créer l'utilisateur
        const userDoc = doc(db, DBCollectionUsers, user_id);
        await setDoc(userDoc, userData);
        return true;
    } catch (error) {
        throw error;
    }
}

export const checkUserGiftCode = async (data: { code: string }) => {
    try {
        const { code } = data;
        const dataReference = collection(db, Constants.DBCollectionCards);
        const dataQuery = query(dataReference, where("code", "==", code));
        const response = await getDocs(dataQuery);
        if (response.empty === true) {
            return undefined;
        } else {
            if (response.docs[0] !== undefined) {
                return {
                    key: response.docs[0].id,
                    data: response.docs[0].data()
                }
            } else {
                return undefined;
            }
        }
    } catch (error) {
        throw error;
    }
}

export const getUserGiftCards = async (data: { user_email: string }) => {
    try {
        const { user_email } = data;
        const dataReference = collection(db, Constants.DBCollectionCards);
        const dataQuery = query(dataReference, where("customer_email", "==", user_email));
        const querySnapshot = await getDocs(dataQuery);
        let result = [];
        if (querySnapshot.empty === false) {
            for (const aDocIndex in querySnapshot.docs) {
                if (Object.hasOwnProperty.call(querySnapshot.docs, aDocIndex)) {
                    const anElement = querySnapshot.docs[aDocIndex];
                    let aDoc = {
                        key: anElement.id,
                        data: anElement.data()
                    }
                    result.push(aDoc);
                }
            }
        }
        return result;
    } catch (error) {
        throw (error)
    }
}

export async function redeemedCardInDb(data: { card: any, user: User }) {
    try {
        const { card, user } = data;
        const cardRef = doc(db, Constants.DBCollectionCards, card.key);
        await updateDoc(cardRef, { status: "redeemed", user_email: user.email, user_key: user.uid, redeemed_date: new Date().getTime() });
        return true;
    } catch (error) {
        throw error;
    }
}

export const transfertCardToNewUser = async (data: { card: any, user_email: string }) => {
    try {
        const { card, user_email } = data;
        const cardRef = doc(db, Constants.DBCollectionCards, card.key);
        await updateDoc(cardRef, { customer_email: user_email });
        return true;
    } catch (error) {
        throw error;
    }
}

export const getCollection = async (data: { collection: string, query: string }) => {
    try {
        let dataReference = collection(db, data.collection);
        const querySnapshot = await getDocs(dataReference);
        let result = [];
        if (querySnapshot.empty === false) {
            for (const aDocIndex in querySnapshot.docs) {
                if (Object.hasOwnProperty.call(querySnapshot.docs, aDocIndex)) {
                    const anElement = querySnapshot.docs[aDocIndex];
                    let aDoc = {
                        key: anElement.id,
                        data: anElement.data()
                    }
                    result.push(aDoc);
                }
            }
        }
        return result;
    } catch (error) {
        throw error;
    }
}

export const getDocument = async (data: { collection: string, doc: string }) => {
    try {
        let docRef = doc(db, data.collection);
        const documentSnapshot = await getDoc(docRef);
        return documentSnapshot.data();
    } catch (error) {
        throw error;
    }
}

export const addDocument = async (data: { collection: string, content: any }) => {
    try {
        let dataReference = await addDoc(collection(db, data.collection), data.content);
        return dataReference;
    } catch (error) {
        throw error;
    }
}

export const setDocument = async (data: { aCollection: string, key: string, content: any }) => {
    try {
        const { aCollection, key, content } = data;
        let dataReference = doc(db, aCollection, key);
        const result = await setDoc(dataReference, content);
        return result;
    } catch (error) {
        throw error;
    }
}

export const deleteDocument = async (data: { aCollection: string, key: string, content: any }) => {
    try {
        const { aCollection, key, content } = data;
        let dataReference = doc(db, aCollection, key);
        const result = await deleteDoc(dataReference);
        return result;
    } catch (error) {
        throw error;
    }
}

// DOCS - V4
export const getDBDocs = async (data: { ts: number }) => {
    const { ts } = data;
    try {
        const collectionRef = collection(db, Constants.DBCollectionDocs);
        const collectionQuery = query(collectionRef, where("last_update", ">=", ts));
        const querySnapshot = await getDocs(collectionQuery);
        if (querySnapshot.empty === false) {
            let result = [];
            for (const aDocIndex in querySnapshot.docs) {
                if (Object.hasOwnProperty.call(querySnapshot.docs, aDocIndex)) {
                    const anElement = querySnapshot.docs[aDocIndex];
                    let aDoc = {
                        key: anElement.id,
                        data: anElement.data()
                    }
                    result.push(aDoc);
                }
            }
            return result;
        } else {
            return [];
        }
    } catch (error) {
        throw error;
    }
}

// GAMIFICATION
export const getUserActions = async (data: { user_id: string }) => {
    const { user_id } = data;
    try {
        const actionDoc = doc(db, DBCollectionActions, user_id);
        const querySnapshot = await getDoc(actionDoc);
        if (querySnapshot.exists() === true) {
            const result = querySnapshot.data();
            return result;
        } else {
            return undefined;
        }
    } catch (error) {
        throw error;
    }
}

export const launchUserListener = async (data: { user_id: string }) => {
    const { user_id } = data;
    const user: User = User.getInstance();
    const dbDoc = doc(db, DBCollectionUsers, user_id);
    const dbListener = onSnapshot(dbDoc, async (userSnapshot) => {
        if ((userSnapshot !== null) && (userSnapshot.exists() === true)) {
            user.setDBUserData(userSnapshot.data());
            EventRegister.emit(EventUserAuthDB, user.getUserData());
            EventRegister.emit(Constants.EventFiltersByLevelChanged, {});
        }
    });
    if (dbListeners !== undefined) {
        dbListeners.push(dbListener);
    } else {
        dbListeners = [dbListener];
    }
}

// DOCS HTML / PDF V4
export const docsListener = async () => {
    // A chaque mise à jour d'un document on a un push, même pour le changement d'une vrigule. Je change donc cette appel pour qu'il ne mette à jour les docs qu'au lancement de l'app.
    try {
        let localDocsFromStorage = await getLocalDocs();
        let localDocsData = localDocsFromStorage.data;
        const dbCollection = collection(db, Constants.DBCollectionDocs);
        const dbQuery = query(dbCollection, where("last_update", ">=", localDocsFromStorage.ts));
        const collectionSnapshot = await getDocs(dbQuery);
        if (collectionSnapshot.empty === false) {
            for (const aFbDocDoc in collectionSnapshot.docs) {
                if (Object.prototype.hasOwnProperty.call(collectionSnapshot.docs, aFbDocDoc)) {
                    const element = collectionSnapshot.docs[aFbDocDoc];
                    let anFBDoc = element.data();
                    localDocsData[element.id] = anFBDoc;
                }
            }
        }
        await recordLocalDocs({ data: localDocsData, ts: new Date().getTime() });
    } catch (error) {
        throw error;
    }
}

// SUPERPOWERS V4
export const superPowersListener = async () => {
    let localSuperPowersFromStorage = await getLocalSuperPowers();
    let localSuperPowersData = localSuperPowersFromStorage.data;
    const dbCollection = collection(db, Constants.DBCollectionSuperPowers);
    const dbQuery = query(dbCollection, where("last_update", ">=", localSuperPowersFromStorage.ts));
    const dbListener = onSnapshot(dbQuery, async (collectionSnapshot) => {
        if (collectionSnapshot.empty === false) {
            for (const aFbDocDoc in collectionSnapshot.docs) {
                if (Object.prototype.hasOwnProperty.call(collectionSnapshot.docs, aFbDocDoc)) {
                    const element = collectionSnapshot.docs[aFbDocDoc];
                    let aSuperPowerDoc = element.data();
                    localSuperPowersData[element.id] = aSuperPowerDoc;
                }
            }
        }
        await recordLocalSuperPowers({ data: localSuperPowersData, ts: new Date().getTime() });
    });
    if (dbListeners !== undefined) {
        dbListeners.push(dbListener);
    } else {
        dbListeners = [dbListener];
    }
}

// TIPS V4
export const tipsListener = async () => {
    let localTipsFromStorage = await getLocalTips();
    let localTipsData = localTipsFromStorage.data;
    const dbCollection = collection(db, Constants.DBCollectionTips);
    const dbQuery = query(dbCollection, where("last_update", ">=", localTipsFromStorage.ts));
    const dbListener = onSnapshot(dbQuery, async (collectionSnapshot) => {
        if (collectionSnapshot.empty === false) {
            for (const aFbDocDoc in collectionSnapshot.docs) {
                if (Object.prototype.hasOwnProperty.call(collectionSnapshot.docs, aFbDocDoc)) {
                    const element = collectionSnapshot.docs[aFbDocDoc];
                    let aTipDoc = element.data();
                    localTipsData[element.id] = aTipDoc;
                }
            }
        }
        await recordLocalTips({ data: localTipsData, ts: new Date().getTime() });
    });
    if (dbListeners !== undefined) {
        dbListeners.push(dbListener);
    } else {
        dbListeners = [dbListener];
    }
}

export const activitiesListener = async () => {
    let localActivitiesFromStorage = await getLocalActivities();
    let localActivitiesData = localActivitiesFromStorage.data;
    const dbCollection = collection(db, DBCollectionActivities);
    const dbQuery = query(dbCollection, where("last_update", ">=", localActivitiesFromStorage.ts));
    const dbListener = onSnapshot(dbQuery, async (collectionSnapshot) => {
        if (collectionSnapshot.empty === false) {
            for (const anActivityDoc in collectionSnapshot.docs) {
                if (Object.prototype.hasOwnProperty.call(collectionSnapshot.docs, anActivityDoc)) {
                    const element = collectionSnapshot.docs[anActivityDoc];
                    let anActivity = element.data();
                    if ((localActivitiesData[anActivity.key] !== undefined) && (localActivitiesData[anActivity.key].offline !== undefined)) {
                        anActivity.offline = localActivitiesData[anActivity.key].offline;
                    }
                    localActivitiesData[anActivity.key] = anActivity;
                }
            }
        }
        await recordLocalActivities({ data: localActivitiesData, ts: new Date().getTime() });
        buildLocalDB(localActivitiesData);
    });
    if (dbListeners !== undefined) {
        dbListeners.push(dbListener);
    } else {
        dbListeners = [dbListener];
    }
}

export const gameLabelListener = async () => {
    let localGameLabelFromStorage = await getLocalGameLabels();
    let localGameLabelData = localGameLabelFromStorage.data;
    const dbCollection = collection(db, Constants.DBCollectionGameLabels);
    const dbQuery = query(dbCollection, where("last_update", ">=", localGameLabelFromStorage.ts));
    const dbListener = onSnapshot(dbQuery, async (collectionSnapshot) => {
        if (collectionSnapshot.empty === false) {
            for (const aCategoryDoc in collectionSnapshot.docs) {
                if (Object.prototype.hasOwnProperty.call(collectionSnapshot.docs, aCategoryDoc)) {
                    const element = collectionSnapshot.docs[aCategoryDoc];
                    let aCategory = element.data();
                    localGameLabelData[element.id] = aCategory;
                }
            }
        }
        await recordLocalGameLabels({ data: localGameLabelData, ts: new Date().getTime() });
    });
    if (dbListeners !== undefined) {
        dbListeners.push(dbListener);
    } else {
        dbListeners = [dbListener];
    }
}

export const gameImagesListener = async () => {
    let localGameImagesFromStorage = await getLocalGameImages();
    let localGameImagesData = localGameImagesFromStorage.data;
    const dbCollection = collection(db, Constants.DBCollectionGameImages);
    const dbQuery = query(dbCollection, where("last_update", ">=", localGameImagesFromStorage.ts));
    const dbListener = onSnapshot(dbQuery, async (collectionSnapshot) => {
        if (collectionSnapshot.empty === false) {
            for (const aCategoryDoc in collectionSnapshot.docs) {
                if (Object.prototype.hasOwnProperty.call(collectionSnapshot.docs, aCategoryDoc)) {
                    const element = collectionSnapshot.docs[aCategoryDoc];
                    let aCategory = element.data();
                    localGameImagesData[element.id] = aCategory;
                }
            }
        }
        await recordLocalGameImages({ data: localGameImagesData, ts: new Date().getTime() });
    });
    if (dbListeners !== undefined) {
        dbListeners.push(dbListener);
    } else {
        dbListeners = [dbListener];
    }
}

export const categoriesListener = async () => {
    let localCategoriesFromStorage = await getLocalCategories();
    let localCategoriesData = localCategoriesFromStorage.data;
    const dbCollection = collection(db, DBCollectionCategories);
    const dbQuery = query(dbCollection, where("last_update", ">=", localCategoriesFromStorage.ts));
    const dbListener = onSnapshot(dbQuery, async (collectionSnapshot) => {
        if (collectionSnapshot.empty === false) {
            for (const aCategoryDoc in collectionSnapshot.docs) {
                if (Object.prototype.hasOwnProperty.call(collectionSnapshot.docs, aCategoryDoc)) {
                    const element = collectionSnapshot.docs[aCategoryDoc];
                    let aCategory = element.data();
                    localCategoriesData[aCategory.key] = aCategory;
                }
            }
        }
        await recordLocalCategories({ data: localCategoriesData, ts: new Date().getTime() });
    });
    if (dbListeners !== undefined) {
        dbListeners.push(dbListener);
    } else {
        dbListeners = [dbListener];
    }
}

// A modifier avec INtegration
export const launchStepsListener = async () => {
    let localLaunchSteps = await getLocalintegrationSteps();
    let localLaunchStepsData = localLaunchSteps.data;
    const dbCollection = collection(db, Constants.DBCollectionLaunchSteps);
    const dbQuery = query(dbCollection, where("last_update", ">=", localLaunchSteps.ts));
    const dbListener = onSnapshot(dbQuery, async (collectionSnapshot) => {
        if (collectionSnapshot.empty === false) {
            for (const aLaunchStepDoc in collectionSnapshot.docs) {
                if (Object.prototype.hasOwnProperty.call(collectionSnapshot.docs, aLaunchStepDoc)) {
                    const element = collectionSnapshot.docs[aLaunchStepDoc];
                    localLaunchStepsData[element.id] = element.data();
                }
            }
        }
        await recordLocalLaunchSteps({ data: localLaunchStepsData, ts: new Date().getTime() });
    });
    if (dbListeners !== undefined) {
        dbListeners.push(dbListener);
    } else {
        dbListeners = [dbListener];
    }
}

export const launchNewsListener = async () => {
    let localNews = await getLocalNews();
    let localNewsData = localNews.data;
    const dbCollection = collection(db, Constants.DBCollectionNews);
    const dbQuery = query(dbCollection, where("last_update", ">=", localNews.ts));
    const dbListener = onSnapshot(dbQuery, async (collectionSnapshot) => {
        if (collectionSnapshot.empty === false) {
            for (const aNewsDoc in collectionSnapshot.docs) {
                if (Object.prototype.hasOwnProperty.call(collectionSnapshot.docs, aNewsDoc)) {
                    const element = collectionSnapshot.docs[aNewsDoc];
                    let aNews = element.data();
                    localNewsData[element.id] = aNews;
                }
            }
        }
        await recordLocalNews({ data: localNewsData, ts: new Date().getTime() });
    });
    if (dbListeners !== undefined) {
        dbListeners.push(dbListener);
    } else {
        dbListeners = [dbListener];
    }
}

export const userActionsListener = async (data: { user_id: string }) => {
    const { user_id = "" } = data;
    const user: User = User.getInstance();
    const dbDoc = doc(db, Constants.DBCollectionActions, user_id);
    const dbListener = onSnapshot(dbDoc, async (documentSnapshot) => {
        if ((documentSnapshot !== null) && (documentSnapshot.exists() === true)) {
            await user.setActionsUserData(documentSnapshot.data());
        }
    });
    if (dbListeners !== undefined) {
        dbListeners.push(dbListener);
    } else {
        dbListeners = [dbListener];
    }
}

export const quotesListener = async (data: { ts: number }) => {
    const { ts = 0 } = data;
    const dbCollection = collection(db, Constants.DBCollectionQuotes);
    const dbQuery = query(dbCollection, where("last_update", ">=", ts));
    const dbListener = onSnapshot(dbQuery, async (collectionSnapshot) => {
        const localQuotesFromStorage = await getLocalQuotes();
        let localQuotesData = localQuotesFromStorage.data;
        if (collectionSnapshot.empty === false) {
            for (const aQuoteDoc in collectionSnapshot.docs) {
                if (Object.prototype.hasOwnProperty.call(collectionSnapshot.docs, aQuoteDoc)) {
                    const element = collectionSnapshot.docs[aQuoteDoc];
                    let aQuote = element.data();
                    localQuotesData[element.id] = aQuote;
                }
            }
        }
        await recordLocalQuotes({ data: localQuotesData, ts: new Date().getTime() });
    });
    if (dbListeners !== undefined) {
        dbListeners.push(dbListener);
    } else {
        dbListeners = [dbListener];
    }
}

// Déblocage de badges
export const unlockedTheBadge = async (data: { badgeId: string, user_id: string }) => {
    const { badgeId, user_id } = data;
    const userActionsRef = doc(db, DBCollectionActions, user_id);
    await runTransaction(db, async transaction => {
        let userActions = await transaction.get(userActionsRef);
        if (userActions.data() !== undefined) {
            let userActionData = userActions.data();
            userActionData.badges[badgeId].status = "unlocked";
            transaction.update(userActionsRef, userActionData);
            return userActionData;
        }
        return userActions;
    }).then((userActions) => {
        return userActions;
    }).catch(error => {
        throw error;
    });
}

export const updateSuperPowersOrder = async () => {
    try {
        const last_update: number = new Date().getTime();
        let superPowerRef = doc(db, Constants.DBCollectionSuperPowers, "selfEsteem");
        await updateDoc(superPowerRef, { ord: 0, last_update });
        superPowerRef = doc(db, Constants.DBCollectionSuperPowers, "criticalThinking");
        await updateDoc(superPowerRef, { ord: 1, last_update });
        superPowerRef = doc(db, Constants.DBCollectionSuperPowers, "collective");
        await updateDoc(superPowerRef, { ord: 2, last_update });
        superPowerRef = doc(db, Constants.DBCollectionSuperPowers, "speak");
        await updateDoc(superPowerRef, { ord: 3, last_update });
        superPowerRef = doc(db, Constants.DBCollectionSuperPowers, "errorTaming");
        await updateDoc(superPowerRef, { ord: 4, last_update });
        superPowerRef = doc(db, Constants.DBCollectionSuperPowers, "focus");
        await updateDoc(superPowerRef, { ord: 5, last_update });
        superPowerRef = doc(db, Constants.DBCollectionSuperPowers, "emotionsTaming");
        await updateDoc(superPowerRef, { ord: 6, last_update });
        return true
    } catch (error) {
        throw error;
    }
}

export const updateAnActivity = async (data: { activity: Activity }) => {
    try {
        let { activity } = data;
        activity.last_update = new Date().getTime();
        const userActivityDoc = doc(db, DBCollectionActivities, activity.key);
        await setDoc(userActivityDoc, activity, { merge: true });
        return true
    } catch (error) {
        throw error;
    }
}

//Nouvelle Gamification
export const onActivityCompleted = async (data: { activityKey: string, iteration: number, categoryKey: string, sectionKey: string, detail: string, menu: string }) => {
    const user: User = User.getInstance();
    const { activityKey, iteration = 1, categoryKey, sectionKey, detail, menu } = data;
    const numberOfPointsForActivity = 10;
    if ((activityKey !== undefined) && (user !== undefined)) {
        const pointsGained = iteration * numberOfPointsForActivity;
        const userActionRef = doc(db, DBCollectionActions, user.uid);
        // On crée l'historique des points de l'enfant
        const date = new Date();
        const historyData = {
            ts: date.getTime(),
            action: "activity",
            type: "modal",
            pts: pointsGained,
            uid: activityKey,
            sId: sectionKey,
            menu,
            sbId: categoryKey,
            nbOfIteration: iteration,
            detail: detail !== undefined ? detail : "",
            build
        };
        await runTransaction(db, async transaction => {
            let userActions = await transaction.get(userActionRef);
            if (userActions.data() !== undefined) {
                let userActionData = userActions.data();
                let pts = 0;
                if (userActionData.pts !== undefined) {
                    pts = userActionData.pts;
                }
                pts = pts + pointsGained;
                let history = [];
                if (userActionData.history !== undefined) {
                    history = userActionData.history;
                }
                history.push(historyData);
                const latest = [historyData];
                transaction.update(userActionRef, { pts, history, latest });
                return true;
            } else {
                const newData = {
                    pts: pointsGained,
                    history: [historyData],
                    badges: {},
                    level: 1,
                };
                transaction.set(userActionRef, newData);
                return true;
            }
        }).then((success) => {
            return success;
        }).catch((error) => {
            throw error;
        });
    }
}

export const updateActions = async (data: { pts: number, last_connexion_date: number, days_in_a_row: number }) => {
    const { pts, last_connexion_date, days_in_a_row } = data;
    const user: User = User.getInstance();
    const userActionDoc = doc(db, DBCollectionActions, user.uid);
    await updateDoc(userActionDoc, { pts, last_connexion_date, days_in_a_row, last_update: new Date().getTime() });
}

// Vérification de la version pour alerte ou solicitation mise à jour de l'app
export const checkVersionUpgrade = async () => {
    const versionDoc = doc(db, Constants.DBCollectionSettings, "version");
    const versionStatus = await getDoc(versionDoc);
    let askUser = false;
    let forceUser = false;
    let updateMsg = "";
    let updateTitle = "";
    if ((versionStatus !== undefined) && (versionStatus.data() !== undefined)) {
        const versionData = versionStatus.data();
        const currentVersion = versionData.build !== undefined ? parseInt(versionData.build) : 0;
        if (currentVersion > parseInt(build)) {
            const forceVersion = versionData.force !== undefined ? parseInt(versionData.force) : 0;
            const askVersion = versionData.ask !== undefined ? parseInt(versionData.ask) : 0;
            if (forceVersion >= parseInt(build)) {
                //On doit forcer la mise à jour de la version
                forceUser = true;
                updateMsg = versionData.force_msg[getLanguage()];
                updateTitle = versionData.force_title[getLanguage()];
            } else if (askVersion >= parseInt(build)) {
                //On doit demander la mise à jour de la version
                //On regarde si la personne a déjà ignoré la mise à jour proposée
                const upgradeStatus = await getItemFromAsyncStorage({itemKey : AsyncStorageKey.upgrade});
                if (upgradeStatus !== null) {
                    //On regarde ce qui a été enregistré
                    const updgradeData = JSON.parse(upgradeStatus);
                    const lastUpgradeRequest = updgradeData.version !== undefined ? parseInt(updgradeData.version) : 0;
                    const lastUpgradeIgnored = updgradeData.ignored !== undefined ? updgradeData.ignored : false;
                    if ((lastUpgradeRequest >= askVersion) && (lastUpgradeIgnored === true)) {
                        //On va regarder s'il l'a ignoré il y a plus de 3 jours
                        if (updgradeData.date !== undefined) {
                            const todayTime = new Date().getTime();
                            const daysInMS = 3 * 24 * 60 * 60 * 1000;
                            if (todayTime - updgradeData.date > daysInMS) {
                                // Plus de 3 jours, donc il doit être averti de la mise à jour
                                askUser = false;
                            } else {
                                // Moins de 3 jours, donc il ne doit pas être averti de la mise à jour
                                askUser = false;
                            }
                        } else {
                            // On ne sait pas quand est-ce qu'il l'a ignoré, donc il doit être averti de la mise à jour
                            askUser = true;
                        }
                    } else {
                        //Il doit être averti de la mise à jour
                        askUser = true;
                    }
                } else {
                    askUser = true;
                }
                if (askUser === true) {
                    updateMsg = versionData.update_msg[getLanguage()];
                    updateTitle = versionData.title[getLanguage()];
                }
            }
            if (forceUser === true) {
                // On regarde d'abord si on doit forcer
                return ({ updateUpgradeRequest: true, details: { force: true, updateMsg, updateTitle } });
            } else if (askUser === true) {
                // On regarde ensuite si on doit suggère
                return ({ updateUpgradeRequest: true, details: { force: false, updateMsg, updateTitle } });
            } else {
                return ({ updateUpgradeRequest: false, details: {} });
            }
        } else {
            return ({ updateUpgradeRequest: false, details: {} });
        }
    } else {
        return ({ updateUpgradeRequest: false, details: {} });
    }
}

export const getCardWithCode = async (data: { code: string }) => {
    const { code } = data;
    try {
        const cardDoc = doc(db, Constants.DBCollectionPremiumCards, code);
        const querySnapshot = await getDoc(cardDoc);
        if (querySnapshot.exists() === true) {
            const premiumCard = querySnapshot.data();
            return premiumCard;
        } else {
            return undefined;
        }
    } catch (error) {
        throw error;
    }
}

export async function redeemedPremiumCardInDb(data: { card: PremiumCard, user: User }) {
    const { card, user } = data;
    try {
        const cardDoc = doc(db, Constants.DBCollectionPremiumCards, card.code);
        await updateDoc(cardDoc, { status: "redeemed", user_email: user.email, user_key: user.uid, redeemed_date: new Date().getTime() });
        return true;
    } catch (error) {
        throw error;
    }
}

export const updateUserForBrevo = async (user_id: string, user_profile: string, school_id?: string) => {
    if (school_id !== undefined) {
        await addMultipleDataToUser({
            pairs: [
                { key: "profile", value: user_profile },
                { key: "school_id", value: school_id }
            ],
            user_id
        });
    } else {
        await addDataToUser({ key: "profile", value: user_profile, user_id });
    }
}